import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { LazyLoadEvent, CheckboxModule } from 'primeng';
import { IERegion } from '../../interfaces/eregion';
import { IERegionFilter } from '../../interfaces/eregion-filter';
import { IPageResult } from '../../interfaces/page-result';
import { EngineiusRegionService } from '../../services/engineius-region.service';
import { OrganisationsService } from '../../services/organisations.service';

// todo: double check broadcast service
@Component({
  selector: 'eregions-postcodes',
  templateUrl: './manage-eregion-postcodes.component.html',
})
export class ERegionPostcodesComponent implements OnInit {
  public page: IPageResult<IERegion> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<IERegionFilter>;
  public filterVal: IERegionFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public region: IERegion;
  public filterString: string;
  public ukcodes: string[];
  public londoncodes: string[];
  public postcodesDialogVisible: boolean = false;
  public dlgPostcodesUK: string[] = [];
  public dlgPostcodesLondon: string[] = [];
  public selectedRegionId: number;

  constructor(
    private EngineiusRegionService: EngineiusRegionService,
    private orgService: OrganisationsService,
  ) {}

  ngOnInit() {
    this.filter = new Subject<IERegionFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next({ first: 0, rows: 10 });
  }

  load(filter: IERegionFilter) {
    this.EngineiusRegionService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  close() {
    this.displayDialog = false;
  }

  loadRegion(id: number) {
    this.orgService.geteregionpostcodes(id).then((result) => {
      this.ukcodes = [];
      this.londoncodes = [];
      result.forEach((o) => {
        if (o.isLondon) {
          this.londoncodes.push(o.postcode);
        } else {
          this.ukcodes.push(o.postcode);
        }
      });
    });
  }

  save() {
    var postcodes: any[] = [];
    this.ukcodes.forEach((o) => postcodes.push({ postcode: o, isLondon: false }));
    this.londoncodes.forEach((o) => postcodes.push({ postcode: o, isLondon: true }));

    this.orgService.updateERegionPostcodes(this.selectedRegionId, postcodes);
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.loadRegion(item.id);
    this.selectedRegionId = item.id;
    this.postcodesDialogVisible = true;
  }

  dlgSavePostcodes() {
    this.save();
    this.postcodesDialogVisible = false;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    // map grid lazy load event to filter
    var eventString = JSON.stringify(event);
    if (eventString === this.filterString) return;
    console.log(event);
    this.filter.next(event);
  }
}
